import us from '../../defines';
import { setIconState } from '../../toolbar';
import { triggerUScopeEvent } from '../../_uScope';
import { translate } from 'shared/services/I18nService';

const $t = translate.scope('uScope.extensions.settings-service.visibility-panel');

export default function VisibilityPanel (uScope, userConfig, settingsPanel) {
  var jRoot;
  var jPanel;
  var jParent;
  var jVizAllCheckBox; // the "check all" checkbox
  var jVizCheckBoxes; // array of all viz check boxes
  var isVisibilityPanelOpen = false;

  // ............................................ check() public
  //    This function shows/hides the specified overlay
  //    using the visibility checkboxes    which updates the user preferences.

  this.check = function (clsOverlay, bCheck) {
    var isVisible = isOverlayVisible_(clsOverlay);
    if (bCheck == isVisible) { // if the checkbox is already in the desired state, return
      return;
    }

    for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
      if (clsOverlay == jVizCheckBoxes[b].name) {
        jVizCheckBoxes[b].click(); // set the visibility check box to the desired checked state
        break;
      }
    }
  };

  // ............................................ toggleVisibilityPanel_() local
  //    This function shows/hides the visibility panel
  var toggleVisibilityPanel_ = function () {
    isVisibilityPanelOpen = !isVisibilityPanelOpen;

    if (isVisibilityPanelOpen) {
      jPanel.dialog('open');

      // position the fly out panel
      var rootPos = jRoot.offset(); // root div position relative to the document
      var thisImg = uScope.getThisImage();
      if (thisImg) {
        var crOffset = thisImg.toolbar.getOffsetRect();
        jParent.offset({ 'left': rootPos.left + crOffset.x, 'top': rootPos.top + crOffset.y });
      } else {
        jParent.offset({ 'left': rootPos.left + 2, 'top': rootPos.top + 2 });
      }

      for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) { // set the visibility check boxes checked state
        jVizCheckBoxes[b].checked = isOverlayVisible_(jVizCheckBoxes[b].name);
      }

      jVizAllCheckBox[0].checked = areAllVisible_(); // set the "all checked" check box
    } else {
      jPanel.dialog('close');
    }
  };

  // ............................................ isOverlayVisible_() local
  var isOverlayVisible_ = function (clsOverlay) {
    var rtnVisible;
    if (clsOverlay === us.clsDIVGUAGES) { // because the tilemeter auto-hides, get its current preference
      rtnVisible = userConfig.get(us.clsDIVGUAGES);
    } else if (clsOverlay === us.CVSHEATMAP) {
      rtnVisible = userConfig.get(us.CVSHEATMAP);
    } else {
      rtnVisible = $('.' + clsOverlay).is(':visible');
    }
    return rtnVisible;
  };
  // ............................................ areAllVisible_() local
  var areAllVisible_ = function () {
    return (jVizCheckBoxes.filter(':checked').length === jVizCheckBoxes.length);
  };
  // ............................................ bindEvents_() local
  // bindEvents_ - This function adds the configuration panel event handlers.
  //
  //    Note that an exception is made here and the namespace is not an image's namespace.

  var bindEvents_ = function () {
    var namespace = '.toolbar';
    var selector = '.' + us.TBSETTINGS + '-';
    selector = selector + 'e, ' + selector + 'a';

    // ............................................ visibility panel open/close
    jRoot.on('click' + namespace, selector, function (e) {
      toggleVisibilityPanel_();
      setIconState($('#' + us.TBSETTINGS), us.TBSETTINGS, isVisibilityPanelOpen ? 'active' : 'enabled');
      return false; // prevents autopan from activating
    });

    jRoot.on('click' + namespace, '#' + us.idOPTIONSBTN, function (e) { // open options panel
      settingsPanel.show(true);
      // If the user is opening the settings dialog, he probably isn't interested in the visibility panel anymore.
      toggleVisibilityPanel_();
    });

    jRoot.on('click' + namespace, '#' + us.idVIZALLCHECKBOX, function (e) {
      var ix, len;
      // the checked state into this fn is the changed state
      if (areAllVisible_()) { // if all visible now,  hide all
        for (ix = 0, len = jVizCheckBoxes.length; ix < len; ix++) {
          jVizCheckBoxes[ix].click();
        }
      } else {
        for (ix = 0, len = jVizCheckBoxes.length; ix < len; ix++) {
          var isVisible = isOverlayVisible_(jVizCheckBoxes[ix].name);
          if (!isVisible) {
            jVizCheckBoxes[ix].click();
          }
        }
      }
    });

    jPanel.on('change' + namespace, '.' + us.clsVIZCHECKBOX, function (e) {
      userConfig.set(this.name, this.checked); // setting pref triggers evUSERPREFSET
      jVizAllCheckBox[0].checked = areAllVisible_(); // set the "all checked" check box

      uScope.overlayRefresh(); // arrange all overlays of all views
      uScope.setImageSelected(uScope.getSelImageIdx(), true); // now force selection to hide overlays on non-selected images
    });

    jRoot.on('click' + namespace, '#' + us.idHMCLEARBTN, function (e) { // thumbnail heat map clear
      triggerUScopeEvent(us.evHEATMAPCLEAR, {});
    });
  };

  // ............................................ init_() local
  var init_ = function () {
    jRoot = $(us.idHashROOT);
    jPanel = $('<div id="us_idconfigpanel" class=' + us.clsPANEL + ' ' + us.clsPANELCLICKCLOSE + '></div>');

    jPanel.dialog({
      appendTo: us.idHashROOT,
      autoOpen: false,
      title: $t('visibility'),
      closeOnEscape: true,
      draggable: true,
      stack: true,
      resizable: false,
      dialogClass: 'uscope-dialog',
      width: 160,
      closeText: $t('close'),
      close () {
        isVisibilityPanelOpen = false;
      }
    });

    var html = '';

    // use a template and replace scheme to build the visibility check box list
    var checkboxes = '<div>';
    checkboxes += `<br><label><input id="${us.idVIZALLCHECKBOX}"  type="checkbox" title="Select All"  name="ALLOVERLAYS" value="All"/> ${$t('all')}</label>`;

    var template = `<br><label><input class="${us.clsVIZCHECKBOX}" type="checkbox" title="TIP"  name="OVERLAYCLASS" value="OVERLAYCLASS"/> TEXT </label>`;
    if (us.ENABLELABEL) {
      checkboxes += template.replace('TIP', `${$t('label')}`)
        .replace(/OVERLAYCLASS/g, us.clsDIVLABEL)
        .replace('NUM', 0)
        .replace('TEXT', `${$t('label')}`);
    }
    if (us.ENABLEMAG) {
      checkboxes += template
        .replace('TIP', `${$t('magnifier-glass')}`)
        .replace(/OVERLAYCLASS/g, us.clsDIVMAG)
        .replace('NUM', 1)
        .replace('TEXT', `${$t('magnifier-glass')}`);
    }
    if (us.ENABLEROTATION) {
      checkboxes += template
        .replace('TIP', `${$t('rotation-dial')}`)
        .replace(/OVERLAYCLASS/g, us.clsROTATIONDIV)
        .replace('NUM', 2)
        .replace('TEXT', `${$t('rotation-dial')}`);
    }
    if (us.ENABLESCALEBAR) {
      checkboxes += template
        .replace('TIP', `${$t('scale-bar')}`)
        .replace(/OVERLAYCLASS/g, us.clsDIVSCALEBAR)
        .replace('NUM', 3)
        .replace('TEXT', `${$t('scale-bar')}`);
    }
    if (us.ENABLETHUMB) {
      checkboxes += template.replace('TIP', `${$t('thumbnail')}`)
        .replace(/OVERLAYCLASS/g, us.clsDIVTHUMBNAIL)
        .replace('NUM', 5)
        .replace('TEXT', `${$t('thumbnail')}`);
    }
    if (us.ENABLEHEATMAP) {
      checkboxes += template
        .replace('TIP', `${$t('heat-map')}`)
        .replace(/OVERLAYCLASS/g, us.CVSHEATMAP)
        .replace('NUM', 6)
        .replace('TEXT', `${$t('heat-map')}`);

      var heatmapClearBtn = `
<button class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" Title="${$t('clear-heat-map')}"  id="${us.idHMCLEARBTN}">
  ${$t('clear')}
</button>`;
      checkboxes += heatmapClearBtn;
    }
    if (us.ENABLEZOOMCTL) {
      checkboxes += template
        .replace('TIP', 'Zoom Control')
        .replace(/OVERLAYCLASS/g, us.clsDIVZOOMCTL)
        .replace('NUM', 7)
        .replace('TEXT', `${$t('zoom-control')}`);
      checkboxes += template
        .replace('TIP', 'Zoom Slider')
        .replace(/OVERLAYCLASS/g, us.clsDIVZOOMSLIDER)
        .replace('NUM', 8)
        .replace('TEXT', `${$t('zoom-slider')}`);
    }
    html += checkboxes + '<div>';

    var horizLine = '<br><div class="tooldivider"></div>';
    var settingsPanelBtn = `
<div class="settings-button-container">
  <button class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" Title="${$t('config-options')}"  id="${us.idOPTIONSBTN}"  type="button" style="margin: 0;">
    ${$t('options')}
  </button>
</div>`;
    html += horizLine + settingsPanelBtn;

    jPanel.html(html);

    jVizCheckBoxes = jPanel.find('.' + us.clsVIZCHECKBOX); // get for quick reference
    jVizAllCheckBox = jPanel.find('#' + us.idVIZALLCHECKBOX);
    jParent = jPanel.parent();

    bindEvents_(); // add event handlers
  };

  // ............................................ construction
  init_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/settings-services/visibility-panel.js